// Built-ins
import React from "react";

// Custom Made Components
import NavigationBar from "../../core/navigation_bar/navigation_bar";
import Footer from "../../core/footer/footer";
import axios from "axios";

// Modules / Functions
import filterFactory, { textFilter, selectFilter } from "react-bootstrap-table2-filter";
import ToolkitProvider from "react-bootstrap-table2-toolkit";
import Swal from "sweetalert2";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import AddTaxationProjectModal from "../../modals/create/add_taxation_project";
import OverviewIdCell from "../../common/OverviewIdCell";
import OverviewLinkIcon from "../../common/OverviewLinkIcon";

// CSS
import "react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";

// Global Variables
import {
  paginationOptions,
  headers,
  pageHeader,
  loader,
} from "../../global_vars";

// Variables
window.Swal = Swal;

// API endpoint
const ALL_TAXATION_PROJECTS = "https://ultima.icsgr.com/api/data_management/taxation_projects/";

const columns = [
  {
    dataField: "taxproj_id",
    text: "Taxation ID",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => <OverviewIdCell entity="taxation_project" id={row.taxproj_id} />,
  },
  {
    dataField: "client.fullname",
    text: "Client",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => {
      const cl = row.client;
      if (!cl) return "";
      const label = `${cl.surname ? cl.surname + " " : ""}${cl.name || cl.fullname || ""}`.trim();
      const cid = cl.client_id;
      if (!cid || !label) return label;
      return (
        <span className="d-inline-flex align-items-center flex-wrap" style={{ gap: "0.35rem" }}>
          <OverviewLinkIcon entity="client" id={cid} title={label} />
          <span>{label}</span>
        </span>
      );
    },
  },
  {
    dataField: "consultant.fullname",
    text: "Consultant",
    sort: true,
    filter: textFilter(),
    formatter: (cell, row) => row.consultant?.fullname || "",
  },
  {
    dataField: "taxuse",
    text: "Tax Use",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "deadline",
    text: "Deadline",
    sort: true,
    filter: textFilter(),
  },
  {
    dataField: "declaredone",
    text: "Declared",
    sort: true,
    filter: selectFilter({
      options: { "": "All", true: "Yes", false: "No" },
      defaultValue: "",
      onFilter: (filterVal, data) => {
        if (filterVal === "" || filterVal === undefined || filterVal === null) return data;
        return data.filter((row) => String(row.declaredone) === String(filterVal));
      },
    }),
    formatter: (cell) => (cell ? "Yes" : "No"),
  },
  {
    dataField: "declarationdate",
    text: "Declaration Date",
    sort: true,
    filter: textFilter(),
  },
];

const defaultSorted = [
  {
    dataField: "deadline",
    order: "desc",
  },
];

class AllTaxationProjects extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      all_taxation_projects: [],
      is_loaded: false,
    };
  }

  fetchTaxationProjects = () => {
    const currentHeaders = {
      ...headers,
      "Authorization": "Token " + localStorage.getItem("userToken")
    };

    axios
      .get(ALL_TAXATION_PROJECTS, {
        headers: currentHeaders,
      })
      .then((res) => {
        let allItems = [];
        if (Array.isArray(res.data)) {
          allItems = res.data;
        } else if (res.data && Array.isArray(res.data.results)) {
          allItems = res.data.results;
        } else if (res.data && Array.isArray(res.data.data)) {
          allItems = res.data.data;
        } else if (res.data && res.data.all_taxation_projects) {
          allItems = res.data.all_taxation_projects;
        } else {
          console.warn('Unexpected API response structure:', res.data);
          allItems = [];
        }
        this.setState({
          all_taxation_projects: allItems,
          is_loaded: true,
        });
      })
      .catch((e) => {
        console.error('Error fetching taxation projects:', e);
        if (e?.response?.status === 401) {
          this.setState({ forbidden: true });
        } else {
          Swal.fire({
            icon: "error",
            title: "Error",
            text: "Failed to load taxation projects. Please try again.",
          });
        }
        this.setState({ all_taxation_projects: [], is_loaded: true });
      });
  };

  componentDidMount() {
    this.fetchTaxationProjects();
  }

  render() {
    const tableData = Array.isArray(this.state.all_taxation_projects) ? this.state.all_taxation_projects : [];

    return (
      <>
        <NavigationBar />
        <div className="mainContainer">
          {pageHeader("all_taxation_projects")}
          <div className="contentContainer">
            <div className="contentBody">
              {this.state.is_loaded ? (
                <>
                  <ToolkitProvider
                    bootstrap4
                    keyField="taxproj_id"
                    data={tableData}
                    columns={columns}
                    search
                    condensed
                  >
                    {(props) => (
                      <div>
                        <BootstrapTable
                          {...props.baseProps}
                          pagination={paginationFactory(paginationOptions)}
                          filter={filterFactory()}
                          defaultSorted={defaultSorted}
                          hover
                          bordered={false}
                          striped
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                  <div className="contentHeader">
                    <AddTaxationProjectModal onTaxationProjectCreated={this.fetchTaxationProjects} />
                  </div>
                </>
              ) : (
                <div>{loader()}</div>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </>
    );
  }
}

export default AllTaxationProjects;
